/* eslint-disable */
import React, { useState } from "react";
// @material-ui/core components
import {
  Input,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Search from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { RemoveRedEye } from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import { db, auth } from "../../Firebase/firebase.js";
import ls from "local-storage";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";
const useStyles = makeStyles(styles);

export default function MyPrize() {
  const theme = useTheme();
  const classes = useStyles();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));

  /////////Other hooks//////////
  //Seach
  const searchref = React.useRef("");
  const [searchflag, setsearchflag] = React.useState(true);
  //View
  const [viewflag, setviewflag] = React.useState(false);
  //Table Row Data
  const [rows, setRows] = React.useState([]);
  const [Prizerows, setPrizeRows] = React.useState([]);

  //Handling AddFisherman Dialog
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (row) => {
    console.log(row);
    getPrize(row.docId);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  //Table Style
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  //Get data (Read)
  var getFishermen = () => {
    let newArray = [];
    db.collection("eventRegistration")
      .where("uid", "==", ls.get("currentcustomerUid"))
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setRows(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  var getPrize = (uid) => {
    let newPrize = [];
    db.collection("winners")
      .where("registrationId", "==", uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newPrize.push(doc.data());
        });
        setPrizeRows(newPrize);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  React.useEffect(() => {
    if (ls.get("currentcustomerUid") === "") {
    } else {
      getFishermen();
    }
  }, []);

  return (
    <>
      <Box pb={3} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer
            component={Paper}
            style={{ height: 450, overflow: "scroll", display: "inline-block" }}
          >
            <Table
              stickyHeader
              style={{ width: "100%" }}
              className={classes.table}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ width: "20%" }}
                    className={(classes.tableheadercell, classes.tablehead)}
                  >
                    Fisherman ID
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Name
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Email
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    DOB
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Address
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Contact Number
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.ID}>
                    <TableCell
                      //  onClick={() => viewFisherman(row)}
                      //   style={{ color: "blue" }}
                      component="th"
                      scope="row"
                    >
                      {row.docId}
                    </TableCell>

                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.dob}</TableCell>
                    <TableCell align="left">{row.address}</TableCell>
                    <TableCell align="left">{row.contact}</TableCell>
                    <TableCell align="left">
                      <div>
                        <IconButton onClick={() => handleClickOpen(row)}>
                          <RemoveRedEye
                            style={{ color: "#171942", width: "18" }}
                          />
                        </IconButton>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer justify="flex-end">
        <GridItem>
          <Dialog
            open={open}
            maxWidth="xl"
            onClose={handleClose}
            aria-labelledby="event-title"
            aria-describedby="event-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="event-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
                <h5 style={{ display: "inline-block" }}>Prizes</h5>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 600, width: 600 }}>
              {mobileratio ? <br></br> : <br></br>}
              {Prizerows.map((row) => (
                <Box m={3} pt={5}>
                  <Card
                    className={classes.root}
                    style={{ backgroundColor: "#171942" }}
                  >
                    <CardActionArea>
                      <CardMedia
                        style={{ height: 0, paddingTop: "56%" }}
                        image={row.image}
                      />
                      <CardContent>
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="h2"
                          style={{ color: "white", fontWeight: "bold" }}
                        >
                          {row.prizeName}
                        </Typography>
                        <h5
                          style={{
                            display: "inline-block",
                            fontWeight: "lighter",
                            fontSize: 18,
                            color: "white",
                          }}
                        >
                          {row.prizeCategory}
                        </h5>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Box>
              ))}
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    </>
  );
}
